class CustomerIntegrationsService {
  constructor(httpDim, config, $q, localStorageService) {
    this.name = 'customerIntegrations';
    this.httpDim = httpDim;
    this.config = config;
    this.$q = $q;
    this.localStorageService = localStorageService;
  }

  setIntegrationTypes() {
    return this.getAllIntegrations()
      .then(this.storeIntegrations.bind(this));
  }

  getAllIntegrations({customerId, type = null, key = null, showContentLoader = false} = {}) {
    let url = `${this.config.apiRoot}/customerIntegrations/all`;
    url += customerId ? `?customerId=${customerId}` : '';
    url += type ? `&type=${type}` : '';
    url += key ? `&key=${key}` : '';
    return this.httpDim.get(url, {}, showContentLoader);
  }

  storeIntegrations(response) {
    let types = response.data.content.map((integration) => { return integration.type; });
    const licensingType = response.data.content.filter(integration => integration.key === 'licensingType');
    let uniqueTypes = types.filter((type, index, self) => { return index === self.indexOf(type); });
    this.localStorageService.set('integrationTypes', uniqueTypes);
    licensingType && licensingType.length && licensingType[0].value && this.localStorageService.set('licensingType', licensingType[0].value);
  }

  getSchemas() {
    let url = `${this.config.apiRoot}/customerIntegrations/schemas`;
    return this.httpDim.get(url, this.config);
  }

  getSchema(type) {
    let url = `${this.config.apiRoot}/customerIntegrations/schemas/${type}`;
    return this.httpDim.get(url, this.config);
  }

  getCustomerIntergration(type, key, customerId, showContentLoader = false) {
    let url = `${this.config.apiRoot}/customerIntegrations?type=${type}`;
    if(key) {
      url += `&key=${key}`;
    }
    if(customerId) {
      url += `&customerId=${customerId}`;
    }
    return this.httpDim.get(url, {}, showContentLoader);
  }

  create(customerIntegrations) {
    let url = `${this.config.apiRoot}/customerIntegrations`;
    return this.httpDim.post(url, customerIntegrations, this.config);
  }

  update(customerIntegrations) {
    let url = `${this.config.apiRoot}/customerIntegrations`;
    return this.httpDim.put(url, customerIntegrations, this.config)
      .catch(this.parseError.bind(this));
  }

  parseError(response) {
    let error = response.data.error;
    let type = error.name.split('.')[0];
    let keys = error.name.split('.')[1].split(',');
    let message = error.message;
    return this.$q.reject({
      type,
      keys,
      message
    });

  }

  validateAeriesConfig(aeriesAPIUrl, aeriesAPIKey) {
    let url = `${this.config.apiRoot}/aeries?url=${aeriesAPIUrl}&key=${aeriesAPIKey}`;
    return this.httpDim.get(url, { timeout: 10000 });
  }

  addCustomerIntegrations(customerId, customerIntegrations) {
    const url = `${this.config.apiRoot}/customerIntegrations?customerId=${customerId}`;
    return this.httpDim.post(url, customerIntegrations, true);
  }

  deleteCustomerIntegrations(customerId, key, value) {
    const url = `${this.config.apiRoot}/customerIntegrations/${customerId}/${key}/${value}`;
    return this.httpDim.delete(url, {}, true);
  }

  unassignByPurchasingAccountNumbers(customerId, purchasingAccountNumbers) {
    const url = `${this.config.apiRoot}/customers/${customerId}/unassign`;
    return this.httpDim.post(url, purchasingAccountNumbers, true);
  }
}

CustomerIntegrationsService.$inject = ['httpDim', 'config', '$q', 'localStorageService'];

export default CustomerIntegrationsService;



// WEBPACK FOOTER //
// ./app/common/customerIntegrations/customerIntegrations.service.js